import URL from 'url-parse';

export const API_BASE_URL = '/auth-server/api';
export const SERVER_IMAGE_PATH='/opt/wildfly/images/';
export const ACCESS_TOKEN = 'accessToken';

export const NAME_MIN_LENGTH = 4;
export const NAME_MAX_LENGTH = 40;

export const USERNAME_MIN_LENGTH = 4;
export const USERNAME_MAX_LENGTH = 15;

export const EMAIL_MAX_LENGTH = 40;

export const PASSWORD_MIN_LENGTH = 6;
export const PASSWORD_MAX_LENGTH = 20;

let defaultServletPath = "/auth-server";

let url = new URL(window.location.href);
let reactPath= url.pathname.startsWith(defaultServletPath) ? defaultServletPath : "/" ;
export const REACT_PATH = reactPath;


export const PDF_MIME_TYPE='application/pdf;charset=utf-8';
export const JPEG_MIME_TYPE='image/jpeg';
export const PNG_MIME_TYPE='image/png';


// WEBPACK FOOTER //
// ./src/constants/index.js